import { useState, useEffect, useCallback } from 'react';
import cadenceGqlCall from '../utils/cadence-gql-call';
import { CADENCE_METRIC_PROGRESS_QUERY } from '../utils/cadence-queries';

/** Fetch per-metric progress data for a cadence. */
const useCadenceMetricProgress = (cadenceId) => {
  const [metrics, setMetrics] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [fetchKey, setFetchKey] = useState(0);

  const refetch = useCallback(() => setFetchKey((k) => k + 1), []);

  useEffect(() => {
    if (!cadenceId) {
      setLoading(false);
      return;
    }

    let cancelled = false;
    setLoading(true);
    setError(null);

    cadenceGqlCall(CADENCE_METRIC_PROGRESS_QUERY, { cadenceId: String(cadenceId) })
      .then((res) => {
        if (!cancelled) {
          setMetrics(res?.cadenceMetricProgress?.metrics || []);
          setLoading(false);
        }
      })
      .catch((err) => {
        if (!cancelled) {
          setError(err.message || 'Failed to fetch metric progress');
          setMetrics([]);
          setLoading(false);
        }
      });

    return () => {
      cancelled = true;
    };
  }, [cadenceId, fetchKey]);

  return { metrics, loading, error, refetch };
};

export default useCadenceMetricProgress;
